module.exports = __webpack_public_path__ + "media/images/emoticons/present-0f5bcf51fbdc09f37ac4dade8408a16f.gif";